<div class="my-3 my-md-5">
    <div class="container-fluid px-4">
            <mat-accordion class="example-headers-align" multi>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                    <div class="row mb-2 mt-2">
                        <div class="col-sm-2 mt-2"><input class="form-control" [(ngModel)]="search" type="text" placeholder="Search" />
                        </div>
                        <div class="col-sm-2 mt-2" *ngIf="myrole!='2' && lead_sources.length > 0">
                            <mat-select  placeholder="Lead Source"  [(ngModel)]="lead_source" multiple>
                                <mat-option value="{{lsources.id}}" *ngFor="let lsources of lead_sources">{{lsources.source_name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Lead Status"  [(ngModel)]="lead_status" (click)="setSearchValue('lead_status')" multiple>
                                <input class="mySearchInput"
                                #lead_status_Search focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'lead_status')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="lead_status_Search">
                                <!-- <mat-option >All</mat-option> -->
                                <mat-option [value]="lstatus.id" *ngFor="let lstatus of leadallStatus">{{lstatus.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2" *ngIf="myrole=='3' || myrole=='1' || myrole=='6' || myrole=='15' || myrole=='18'">
                            <mat-select  placeholder="Bds" [(ngModel)]="bd" (click)="setSearchValue('bds')" multiple #itemSelect="ngModel">
                                <input class="mySearchInput"
                                #bd_search focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'bds')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="bd_search">
                                <div class="btn-group col-sm-12">
                                  <button class="btn btn-primary width50" mat-button (click)="selectAll(itemSelect)">Select All</button>
                                  <button class="btn btn-danger width50" mat-button (click)="deselectAll(itemSelect)">Deselect All</button>
                                </div>

                                
                                <mat-option value="{{bd.id}}" *ngFor="let bd of allbds">{{bd.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2" >
                            <mat-select  placeholder="Circle"  [(ngModel)]="circle" (click)="setSearchValue('circle')" multiple>
                                <input class="mySearchInput"
                                #circleSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'circle')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="circleSearch">
                                <!-- <mat-option >All</mat-option> -->
                                <mat-option value="{{cir.id}}" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                          <mat-select  placeholder="Treatment" [(ngModel)]="treatment" (click)="setSearchValue('treatment')" multiple>
                              <input class="mySearchInput"
                              #treatmentSearch focused="'true'" type="text"
                              (keyup)="searchOnSelect($event.target.value, 'treatment')"
                              (keydown)="$event.stopPropagation()" autocomplete="off"
                              placeholder="Search"
                              id="treatmentSearch">
                              <!-- <mat-option >All</mat-option> -->
                              <mat-option value="{{ltreatment.id}}" *ngFor="let ltreatment of alltreatments">{{ltreatment.name}}</mat-option>
                          </mat-select>
                        </div>
                        </div>
                        <div class="row mb-2 mt-2">
                        
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Bridge Number" [(ngModel)]="bridgeno">
                                <mat-option >All</mat-option>
                                <mat-option value="{{bnumbers.bridge_number}}" *ngFor="let bnumbers of bridge_number_lists">{{bnumbers.bridge_number}} ({{bnumbers.bridge_name}})</mat-option>
                                

                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                          <mat-select  placeholder="Lead Catergory" [(ngModel)]="lead_category_filter" multiple>
                              <mat-option value="{{catergory.id}}" *ngFor="let catergory of treatCategory">{{catergory.name}}</mat-option>
                          </mat-select>
                        </div>

                       <!--  <div class="col-sm-2 mt-2">
                          <mat-select  placeholder="Patient Type" [(ngModel)]="patient_type" multiple>
                            <mat-option value="Members">Members</mat-option>
                            <mat-option value="Corporate">Corporate</mat-option>
                            <mat-option value="Retail">Retail</mat-option>
                            <mat-option value="33">App</mat-option>
                          </mat-select>
                        </div> -->

                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Corporate Lead Filter"  [(ngModel)]="corporate_lead_source" multiple>
                              <mat-option value="32">MediBuddy</mat-option> 
                              <mat-option value="37">Secure Now</mat-option> 
                            </mat-select>
                        </div>

                        <div class="col-sm-2 mt-2">
                          <mat-select  placeholder="Insurance Status"  [(ngModel)]="insurance_status" multiple>
                              
                              <mat-option [value]="0" >Pending</mat-option>
                              <mat-option [value]="1" >Approved</mat-option>
                              <mat-option [value]="2" >Rejected</mat-option>
                              <mat-option [value]="3" >Pre Auth Pending</mat-option>
                              <mat-option [value]="6" >Pre Approval Pending</mat-option>
                              <mat-option [value]="7" >Pre Approval Query</mat-option>
                              <mat-option [value]="8" >Pre Approval Approved</mat-option>
                              <mat-option [value]="9" >Final Approval Pending</mat-option>
                              <mat-option [value]="10" >Final Approval Query</mat-option>
                              <mat-option [value]="11" >Final Approval Approved</mat-option>
                          </mat-select>
                      </div>

                     
                        <!-- <div class="col-sm-2 mt-2" *ngIf="myrole=='1' || myrole=='6'">
                            <mat-select  placeholder="Catergory wise" [(ngModel)]="category_filter">
                                <mat-option>All</mat-option>
                                <mat-option value="2">PCLC</mat-option>
                                <mat-option value="3">VODKA</mat-option>
                                <mat-option value="4">Dental</mat-option>
                            </mat-select>
                        </div> -->
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Payment Mode" [(ngModel)]="payment_mode" multiple>
                                <!-- <mat-option >All</mat-option> -->
                                <mat-option value="Cash">Cash</mat-option>
                                <mat-option value="Cashless">Cashless</mat-option>
                                <mat-option value="Reimbursement">Reimbursement</mat-option>
                                <mat-option value="EMI">EMI</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2" *ngIf="myrole=='1' || myrole=='6' || myrole=='3'">
                          <mat-select  placeholder="Patient Type" [(ngModel)]="patient_type">
                            <mat-option>All</mat-option>
                            <mat-option value="1">Opd Customer</mat-option>
                            <mat-option value="2">Ipd Customer</mat-option>
                            <mat-option value="3">Lab Customer</mat-option>
                            <mat-option value="4">Plan Customer</mat-option>
                            <mat-option value="5">Follow-up Customer</mat-option>
                            <mat-option value="6">Non-Duplicate Customer</mat-option>
                            <mat-option value="7">Dental Customer</mat-option>
                        </mat-select> 
                        </div>
                        <div class="col-sm-2 mt-2">
                          <mat-select placeholder="Gender"  [(ngModel)]="gender_filter">
                              <mat-option value="">All</mat-option>
                              <mat-option value="Male">Male</mat-option>
                              <mat-option value="Female">Female</mat-option>
                          </mat-select>
                      </div>

                      <div class="col-sm-2 mt-2" *ngIf="myrole=='1'">
                        <mat-select  placeholder="Tap Count" [(ngModel)]="tap_count" multiple #tpaSelect="ngModel">
                            <div class="btn-group col-sm-12">
                              <button class="btn btn-primary width50" mat-button (click)="selectAllTap(tpaSelect)">Select All</button>
                              <button class="btn btn-danger width50" mat-button (click)="deselectAllTap(tpaSelect)">Deselect All</button>
                            </div>
                            <mat-option value="{{tap.id}}" *ngFor="let tap of allTapValues">{{tap.name}}</mat-option>
                        </mat-select>
                    </div>
                        <!-- <div class="col-sm-2 mt-2" *ngIf="(myrole=='1' || myrole=='6') && tertiarycityFilter">
                          <mat-select  placeholder="Tertiary City Filter" [(ngModel)]="tertiary_city_filter">
                              <mat-option >All</mat-option>
                              <mat-option value="Chandigarh">Chandigarh</mat-option>
                              <mat-option value="Indore">Indore</mat-option>
                              <mat-option value="Patna">Patna</mat-option>
                              <mat-option value="Kolkata">Kolkata</mat-option>
                              <mat-option value="Bhubaneshwar">Bhubaneshwar</mat-option>
                              <mat-option value="Hapur">Hapur</mat-option>
                              <mat-option value="Others">Others</mat-option>
                          </mat-select>
                      </div> -->

                    </div>
                    <div class="row datepicker_row mb-2 mt-2">
                        <div class="col-sm-2 mt-2" *ngIf="myrole!='16'">
                          <mat-select  placeholder="Pre-Sales Users" [(ngModel)]="pre_sale_users_filter" multiple>
                              <mat-option value="{{psu.id}}" *ngFor="let psu of allpre_sale_users">{{psu.name}}</mat-option>
                          </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-form-field appearance="fill">
                                <mat-label>Enter a date range</mat-label>
                                <mat-date-range-input [rangePicker]="picker">
                                    <input matStartDate #dateRangeStart placeholder="Start date">
                                    <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>
                            </mat-form-field>
                            <mat-icon (click)="clearDate()">clear</mat-icon>

                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-form-field appearance="fill">
                                <mat-label>Enter Follow-Up date range</mat-label>
                                <mat-date-range-input [rangePicker]="picker1">
                                    <input matStartDate #followupdateRangeStart placeholder="Start date">
                                    <input matEndDate #followupdateRangeEnd placeholder="End date" (dateChange)="dateRangeChangefollowUp(followupdateRangeStart, followupdateRangeEnd)">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker1></mat-date-range-picker>
                            </mat-form-field>
                            <mat-icon (click)="clearDateFollowUp()">clear</mat-icon>
                        </div>

                        <div class="col-sm-2 mt-2">
                          <mat-form-field appearance="fill">
                              <mat-label>IPD Date Range Filter</mat-label>
                              <mat-date-range-input [rangePicker]="picker2">
                                  <input matStartDate #ipddateRangeStart placeholder="Start date">
                                  <input matEndDate #ipddateRangeEnd placeholder="End date" (dateChange)="dateRangeIPD(ipddateRangeStart, ipddateRangeEnd)">
                              </mat-date-range-input>
                              <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                              <mat-date-range-picker #picker2></mat-date-range-picker>
                          </mat-form-field>
                          <mat-icon (click)="clearDateIPD()">clear</mat-icon>
                      </div>
                      <div *ngIf="myrole!='14'" class="col-sm-3 mt-6">
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" [(ngModel)]="showopdDonebutIpdNotDone">
                            <span class="custom-control-label">Show Opd done but Ipd not done</span>
                          </label>
                      </div>
                        
                    </div>
                    <div class="row mb-2 mt-2">
                      <div class="col-sm-2 mt-6">
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input"  [(ngModel)]="followupadte" />
                            <span class="custom-control-label">Filter by follow Up Date</span>
                        </label>
                     </div>
                     
                      <div class="col-sm-2 mt-6" *ngIf="myrole=='1' || myrole=='3' || myrole=='6' || myrole=='15' || myrole=='18'">
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input"  [(ngModel)]="displayInactiveUsersLead" />
                            <span class="custom-control-label">Display Inactive Users Lead</span>
                        </label>
                      </div>
                   
                      <div class="col-sm-2 mt-6">
                        <label class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input"  [(ngModel)]="c2crecording" />
                          <span class="custom-control-label">Display C2C Recording Leads</span>
                        </label>
                      </div>

                      <div *ngIf="myrole!='14'" class="col-sm-2 mt-6">
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input"  [(ngModel)]="showInsurance">
                            <span class="custom-control-label">Show Insurance Leads</span>
                          </label>
                    </div>

                    

                    <div class="col-sm-1 mt-2"></div>
                    <div class="col-sm-3 mt-2">
                      <button type="button" class="btn btn-primary ml-2 mb-4" (click)="loadleads(0,perpage)"> <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                      <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i class="fa fa-sync" ></i> Reset Filters</button>

                      <button *ngIf="userId=='89'" [disabled]="sendMessageloading" type="button" class="btn btn-primary ml-2 mb-4" (click)="sendWhatsappMessage()"> <i [ngClass]="{'fa-spin':sendMessageloading}" class="fa fa-sync"></i> Send Whatsapp Message</button>

                    </div>
                    
                    </div>

                </mat-expansion-panel>
            </mat-accordion>

        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-8 p-3">
                    <!-- <button class="btn btn-success mb-4" (click)="saveDetails()" [disabled]="submitted"><i class="fas fa-spin fa-spinner" *ngIf="submitted"></i> Save</button> -->
                    <button type="button" class="btn btn-success ml-2 mb-4" [disabled]="loading" (click)="loadleads(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Refresh Sheet</button>
                    <a *ngIf="myrole=='1' || (myrole=='3' && isCMAccess=='1')" routerLink="/create-lead" class="btn btn-success ml-2 mb-4">
                        <i class="fa fa-plus" aria-hidden="true"></i> Add Lead
                    </a>

                    <button type="button" *ngIf="(myrole=='1' || myrole=='15') && router_uri == '/sheetview'" class="btn btn-success ml-2 mb-4" [disabled]="loading" (click)="exportTrainingLeadData()"><i class="fa fa-file-excel"></i> Export For Q&T</button>


                   
                    
                </div>
                <div class="col-sm-4">
                    <mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator>
                </div>
            </div>
            <div class="text-center" *ngIf="loading"><i class="fa fa-spin fa-spinner fa-2x"></i></div>
            <hot-table [hotId]="id" [colHeaders]="true" [hiddenColumns]="hideColumn" [columnSorting]="false" width="100%" [height]="600" [rowHeaders]="true" [data]="leads" [beforeChange]="onBeforeChange"  [afterOnCellMouseDown]="afterOnCellMouseDownCallBack" licenseKey="non-commercial-and-evaluation" [autoWrapRow]="false" [autoWrapCol]="false">
                <hot-column class="bg-red" style="background: red" data="id" [readOnly]="true" title="ID"></hot-column>
                <hot-column data="patient_id" renderer="html" [readOnly]="true" title="Patient Id"></hot-column>
                <hot-column data="glamyo_patient_id" renderer="html" [readOnly]="true" title="Glamyo Patient Id"></hot-column>
                <hot-column  renderer="html" data="patient_count_data" [readOnly]="true" title="
                Patient Type"></hot-column>
                <!-- <hot-column data="type" [readOnly]="true" title="Patient Type"></hot-column> -->
                <hot-column data="bridge_no" [readOnly]="true" title="Bridge Number"></hot-column>
                <hot-column data="lead_time" [readOnly]="true" title="Lead Created Date"></hot-column>
                <hot-column data="surgery_date" [readOnly]="true" title="Surgery Date"></hot-column>

                <hot-column width="100" [copyable]="false" data="mobile" renderer="html" [readOnly]="true" title="Lead Mobile"></hot-column>

                <!-- For Whatsapp Message -->
                <hot-column width="130" [readOnly]="true" renderer="html" data="chat_messages" title="Send Message"></hot-column>
                <!-- For Whatsapp Message -->

                <!--------Nimbus Click to Call----------->
                <!-- <hot-column renderer="html" data="nimbus_click_to_call" [readOnly]="true" title="Nimbus C2C"></hot-column> -->
                <!--------Nimbus Click to Call----------->

                <!-----Click to Call----------->
                <hot-column renderer="html" data="click_to_call" [readOnly]="true" title="Kaleyra C2C"></hot-column>
                <!-- <hot-column width="250" renderer="html" data="click_to_call_recording" [readOnly]="true" title="Kaleyra C2C Recording"></hot-column> -->
                <!-----Click to Call----------->

                <hot-column renderer="html" data="share_plan" [readOnly]="true" title="Share Plan"></hot-column>
                <hot-column renderer="html" data="shared_plan_details" [readOnly]="true" title="Share Plan Details"></hot-column>

                <hot-column data="lead_name" title="Lead Name"></hot-column>
                <hot-column data="patient_age" title="Patient Age"></hot-column>
                <hot-column data="gender" type="dropdown" [source]="gender" title="Gender"></hot-column>

                <hot-column data="city_name" [readOnly]="true" title="City Name"></hot-column>
                <hot-column data="circle_name" [readOnly]="roleStatus" type="dropdown" [source]="sheetCircle" title="To Circle"></hot-column>
                <!-- <hot-column data="" type="dropdown" [source]="sheetCircle2" title="To Circle2"></hot-column> -->
                <hot-column data="bd_name" [readOnly]="true" title="Lead Owner Name"></hot-column>

                <hot-column data="useremployee_id" [readOnly]="true" title="Employee Id"></hot-column>
                
                <hot-column data="bd_email" [readOnly]="roleStatus" type="dropdown" [source]="bds" title="Lead Owner"></hot-column>
                <hot-column data="problem" [readOnly]="true" title="Problem" width="100"></hot-column>
                <hot-column data="description" title="Description" width="300"></hot-column>
                <hot-column data="call_link" [readOnly]="true"  renderer="html" title="Call Details"></hot-column>
                <hot-column data="dnp_followup_data" [readOnly]="true"  renderer="html" title="DNP/Follow-Up Details"></hot-column>
                <hot-column data="treatment_name" type="dropdown" [source]="treatments" title="Treatment"></hot-column>
                <hot-column [readOnly]="paymentModeRole" data="payment_mode" type="dropdown" allowEmpty="true" [source]="paymentOpt" title="Mode of Payment"></hot-column>
                <hot-column data="followup_date" type="date" allowEmpty="true" dateFormat='DD/MM/YYYY' title="Followup Date"></hot-column>
                <hot-column width="250" data="lead_status_name" type="dropdown" [source]="leadStatus" title="Status"></hot-column>
                
                <hot-column data="qa_comments" [readOnly]="!qaRole" title="QA Comments" width="300"></hot-column>

                

                <!-- insurance fields -->
                <hot-column [readOnly]="adminRole" data="policy_number" title="Policy Number"></hot-column>
                <hot-column [readOnly]="adminRole"  data="corporate" title="Corporate"></hot-column>
                <hot-column [readOnly]="adminRole"  data="employee_id" title="Employee ID"></hot-column>
                <hot-column [readOnly]="adminRole"  data="insurance_company" title="Insurance Company"></hot-column>
                <hot-column [readOnly]="adminRole" data="tpa" title="TPA" ></hot-column>
                <hot-column [readOnly]="adminRole"  data="sum_insured" title="Sum Insured"></hot-column>
                <hot-column [readOnly]="adminRole"  data="room_rent" title="Room Rent"></hot-column>
                <hot-column [readOnly]="adminRole"  data="copay" title="Copay"></hot-column>
                <hot-column [readOnly]="adminRole"  data="insurance_description" title="Insurance Description"></hot-column>
                <hot-column [readOnly]="true" renderer="html" data="insurance_hospital_amount" title="Insurance Hospital Amount"></hot-column>
                <hot-column data="monthly_income" title="Monthly Income"></hot-column>
                <hot-column data="occupation" title="Occupation"></hot-column>
                <!-- <hot-column [readOnly]="true" renderer="html" data="lab_documents" title="Lab Documents"></hot-column> -->


                
                

                <hot-column *ngIf="myrole!='4' && myrole!='14' && myrole!='15'" data="action" width="200px" type="dropdown" [source]="ActionOpt" title="Action"></hot-column>
                <hot-column data="lead_source" renderer="html" [readOnly]="true" title="Lead Source" *ngIf="myrole!='2'"></hot-column>
                <hot-column data="zoho_lead_source" [readOnly]="true" title="Form Lead Source" *ngIf="myrole!='2' && myrole!='14'"></hot-column>
                <hot-column [readOnly]="true" data="keywords" title="Keywords"></hot-column>

                <hot-column renderer="html" data="share_health_product" [readOnly]="true" title="Share Health Product Link"></hot-column>

                <hot-column renderer="html" data="lead_history" [readOnly]="true" title="History" *ngIf="myrole=='1' || userId == '19'"></hot-column>

                <hot-column *ngIf="myrole=='1'" data="churn_count" [readOnly]="true" title="Tap Count"></hot-column>
                

            </hot-table>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>
    </div>
</div>

<!-- Duplicate Modal -->
<div class="modal fade" id="duplicateModal">
    <div class="modal-dialog">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Create Duplicate Lead</h4>
          <button type="button" class="close" (click)="hideduplicateModal()"></button>
        </div>

        <!-- Modal body -->
          <div class="modal-body">
              <div class="form-group">
                  <div class="row">
                    <div class="col-sm-12"><h2>Do you want to create duplicate lead?</h2></div>

                    <div *ngIf="copyData" class="col-sm-12 text-center" style="font-size: 22px;"><span><i class="fa fa-spin fa-spinner"></i> Uploading...</span></div>

                  </div>

              </div>
          </div>

        <!-- Modal footer -->
        <div class="modal-footer">
           <button type="button" class="btn btn-success" (click)="copyLead()">Confirm</button>
          <button type="button" class="btn" (click)="hideduplicateModal()">Close</button>
        </div>
      </div>
    </div>
  </div>

<!--For Show Payment Mode and Treatment not Selected Modal -->
<div class="modal fade" id="paymentTreatmentModal">
    <div class="modal-dialog">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title" style="font-weight: bold;">Action Required</h4>
          <button type="button" class="close" (click)="hideStatusModal('1')"></button>
        </div>

        <!-- Modal body -->
          <div class="modal-body">
                <div class="form-group">
                  <div class="row">
                    <div style="font-size: 18px;" class="col-sm-12 modal-title" id="StatusText"><h2></h2></div>
                  </div>
                </div>
          </div>

        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideStatusModal('1')">Close</button>
        </div>
      </div>
    </div>
  </div>

  <!--For Show Payment Mode and Treatment not Selected Modal -->
<div class="modal fade" id="previousdnpfollowModal">
    <div class="modal-dialog">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title" style="font-weight: bold;">Action Required</h4>
          <button type="button" class="close" (click)="hideStatusModal('2')"></button>
        </div>

        <!-- Modal body -->
          <div class="modal-body">
                <div class="form-group">
                  <div class="row">
                    <div style="font-size: 18px;" class="col-sm-12 modal-title" id="ActionTextMessage"><h2></h2></div>
                  </div>
                </div>
          </div>

        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideStatusModal('2')">Close</button>
        </div>
      </div>
    </div>
  </div>

   <!--For Show Different Payment Mode Error Modal -->
<div class="modal fade" id="paymentModeErrorModal">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title" style="font-weight: bold;">Action Required</h4>
        <button type="button" class="close" (click)="hideStatusModal('3')"></button>
      </div>

      <!-- Modal body -->
        <div class="modal-body">
              <div class="form-group">
                <div class="row">
                  <div style="font-size: 18px;" class="col-sm-12 modal-title" id="PaymentModeErrorMessage"><h2></h2></div>
                </div>
              </div>
        </div>

      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" class="btn" (click)="hideStatusModal('3')">Close</button>
      </div>
    </div>
  </div>
</div>


<!------------For Show lead History------------------->
<!-- The Modal to view history -->
<div class="modal fade" id="myHistoryModal">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
          <h4 class="modal-title">Update History</h4>
          <button type="button" class="close" (click)="closeHistoryPopup()"></button>
      </div>
      <div class="modal-body history_modal">
          <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
            <tbody>
                <tr *ngFor="let updatedLog of updatedLodData">
                    <td class="no-padding-bottom">
                        <div class="small_text" [innerHTML]="updatedLog.message | safe:'html'"></div>
                        <div class="small text-muted small_text_creation">
                            <i class="fas fa-clock"></i> {{updatedLog.created_at*1000|date:'dMMM, yyyy H:mm aa'}}
                        </div>
                    </td>
                </tr>
                <tr *ngIf="!updatedLodData.length && history_loaded">
                    <td>No history found</td>
                </tr>
                <tr *ngIf="history_loading">
                    <td><i class="fa fa-spin fa-spinner"></i></td>
                </tr>
            </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn" (click)="closeHistoryPopup()">Close</button>
      </div>
    </div>
  </div>
</div>


<!-----------------For Click to Call-------------------------->
  <div class="modal fade" id="click_to_call_progress" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title" style="font-weight: bold;">Call Progression:-- {{patient_mobile_num}}</h4>
        </div>
  
        <!-- Modal body -->
          <div class="modal-body">
                <div class="alert alert-danger" *ngIf="progression_msg">
                  <strong>Warning!</strong> {{progression_msg}}
                </div>
                <div class="form-group">
                  <div class="row">
                    <div style="font-size: 18px;" class="col-sm-12 modal-title text-center" id="click_to_call_progress_html">
                      <i class="fa fa-cog fa-spin"></i><br />
                      <h2>Call is under progress.</h2>
                    
                    </div>
                  </div>
                </div>
          </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" [disabled]="end_to_call_btn_disable" class="btn btn-success" (click)="endClicktoCall()">Close</button>
        </div>
      </div>
    </div>
  </div>


<!-----------------For Click to Call-------------------------->
<div class="modal fade" id="nimbus_click_to_call_progress" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title" style="font-weight: bold;">Nimbus Call Progression</h4>
      </div>

      <!-- Modal body -->
        <div class="modal-body">
          <div class="form-group">
            <div class="row">
              <div style="font-size: 18px;" class="col-sm-12 modal-title text-center" id="click_to_call_progress_html">
                <i class="fa fa-cog fa-spin"></i><br />
                <h2>Nimbus Call is under progress.</h2>
              </div>
            </div>
          </div>
        </div>
      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" [disabled]="nimbus_end_to_call_btn_disable" class="btn btn-success" (click)="endNimbusClicktoCall()">Close</button>
      </div>
    </div>
  </div>
</div>

<!-----------------For mobile view OTP-------------------------->
<div class="modal fade" id="mobile_view_otp" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title" style="font-weight: bold;">Display Mobile Number</h4>
      </div>
      <form [formGroup]="otpForm" (submit)="sendOtp()">
        <!-- Modal body -->
          <div class="modal-body">
            <div class="form-group">
              <div class="row">
                <div *ngIf="showmobilebtn" style="font-size: 18px;" class="col-sm-12 modal-title text-center">
                  <div class="col-sm-12 mobileotpdiv">OTP has been send on your ACM/CM. kindly enter OTP here to view Mobile Number</div>
                  <div class="col-sm-6 form-group text-left">
                    <label>Enter OTP</label>
                    <input formControlName="otp" type="number"  class="form-control" />
                  </div>
                  <div *ngIf="otpsubmitted && f.otp.errors" class="col-sm-8 invalid-feedback">
                    <div *ngIf="f.otp.errors.required">OTP is required</div>
                  </div>
                  <div *ngIf="wrongOtpdiv && !f.otp.errors" class="col-sm-8 invalid-feedback">
                    <div>Wrong OTP. Please check again</div>
                  </div>
                  
                </div>
                <div *ngIf="showmobilenumberdiv" class="col-sm-8" style="font-size:16px; font-weight: bold;">
                  <div class="col-sm-12">Mobile Number:-{{leadmobilenumber}}</div>
                </div>
                <div class="col-sm-12 text-center" style="font-size: 22px;" *ngIf="otploader"><i class="fa fa-spin fa-spinner"></i></div>
              </div>
            </div>
          </div>
        <!-- Modal footer -->
        <div class="modal-footer">
          <button *ngIf="!showmobilebtn && !showmobilenumberdiv" [disabled]="sendotpbtn" type="submit" class="btn btn-success">Send OTP</button>
          <button *ngIf="showmobilebtn && !showmobilenumberdiv" type="button" class="btn btn-success" (click)="showMobileNumber()">Show Mobile Number</button>
          <button type="button" class="btn btn-success" (click)="endMobileViewModal()">Close</button>
        </div>
      </form>  
    </div>
  </div>
</div>